import { render, staticRenderFns } from "./Factory.vue?vue&type=template&id=231cae9f&scoped=true&"
import script from "./Factory.vue?vue&type=script&lang=js&"
export * from "./Factory.vue?vue&type=script&lang=js&"
import style0 from "./Factory.vue?vue&type=style&index=0&id=231cae9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231cae9f",
  null
  
)

export default component.exports